module.exports = __webpack_public_path__ + "assets/34632e839add6c1ff56e80f38770b522.mp3";